import React, { useEffect } from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  if (pathname === "/login") {
    return null;
  }

  return (
    <footer className="footer_section">
      <div className="container">
        <div className="row justify-content-between px-lg-5 ms-0 ms-0">
          <div className="col-lg-4 col-md-12 mb-4">
            <img
              src="/assets/images/footer/footer logo.png"
              alt="Adesh-Tours-Web"
              className="footer-logo"
            />
            <p className="footer-description">
              Your trusted travel partner for smooth, memorable, & worry-free
              journeys worldwide.
            </p>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4  col-6 mb-4">
            <h6 className="footer-title">Quick Links</h6>
            <ul className="footer-list">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/home/holidays/city-break">Holidays</Link>
              </li>
              <li>
                <Link to="/location">Location</Link>
              </li>
              <li>
                <Link to="/cruises">Cruises</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4  col-6 mb-4">
            <h6 className="footer-title">Support</h6>
            <ul className="footer-list">
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4  col-6 mb-4">
            <h6 className="footer-title">Social Media</h6>
            <div className="footer-social">
              <span className="social-icon">
                <img
                  src="/assets/images/footer/instagram.png"
                  alt="Instagram"
                  className="social-img"
                  onClick={() =>
                    window.open("https://www.instagram.com", "_blank")
                  }
                />
              </span>
              <span className="social-icon">
                <img
                  src="/assets/images/footer/wtsp.png"
                  alt="Whatsapp"
                  className="social-img"
                  onClick={() =>
                    window.open("https://wa.me/1234567890", "_blank")
                  }
                />
              </span>
              <span className="social-icon">
                <img
                  src="/assets/images/footer/facebook.png"
                  alt="Facebook"
                  className="social-img"
                  onClick={() =>
                    window.open("https://www.facebook.com", "_blank")
                  }
                />
              </span>
              <span className="social-icon">
                <img
                  src="/assets/images/footer/youtube.png"
                  alt="You Tube"
                  className="social-img"
                  onClick={() =>
                    window.open("https://www.youtube.com", "_blank")
                  }
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="all-rights-reserved">
        <div className="footer_copyright">
          <p className="copyright-text">
            © 2026 Your Adesh Tours and Travels. All Rights Reserved | Developed
            by{" "}
            <Link
              className="link"
              to="https://profcymaglobal.com"
              target="_blank"
              style={{ color: "#fff", marginLeft: "6px" }}
            >
              Profcyma Solutions Pvt Ltd
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
